"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractService2 = _interopRequireDefault(require("../../AbstractService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * This class handles adding items to the One Web shopping list.
 */
var OneWebShoppingListService = /*#__PURE__*/function (_AbstractService) {
  _inherits(OneWebShoppingListService, _AbstractService);

  var _super = _createSuper(OneWebShoppingListService);

  function OneWebShoppingListService() {
    _classCallCheck(this, OneWebShoppingListService);

    return _super.apply(this, arguments);
  }

  _createClass(OneWebShoppingListService, [{
    key: "addToShoppingList",

    /**
     * Adds items to cart.
     *
     * @param {object} options Options object.
     * @param {string} options.endpoints API endpoints.
     * @param {string} options.token User token.
     * @param {string} options.apiLocalePath API locale path.
     * @param {object[]} options.items Items.
     * @param {string} options.bagName List name.
     * @returns {Promise} Promise object.
     */
    value: function addToShoppingList(options) {
      var _this = this;

      return this.__getListId(options).then(function (listId) {
        return listId || _this.__createList(options);
      }).then(function (listId) {
        return _this.__setSelectedList(Object.assign({
          listId: listId
        }, options)).then(function () {
          return _this.__addItemsToList(Object.assign({
            listId: listId
          }, options));
        });
      });
    }
    /**
     * Returns list count.
     *
     * @param {object} options Options object.
     * @param {string} options.endpoints API endpoints.
     * @param {string} options.token User token.
     * @param {string} options.apiLocalePath API locale path.
     * @param {string} options.bagName List name.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "getListCount",
    value: function getListCount(options) {
      return fetch(options.endpoints.ingkaShoppingListService, {
        method: 'POST',
        headers: this.__getHeaders(options),
        body: this.__getListQuantityBody(options.bagName)
      }).then(this._handleJsonResponse.bind(this)).then(function (response) {
        if (Array.isArray(response.data.lists)) {
          var list = response.data.lists.find(function (list) {
            return list.name === options.bagName;
          });
          return list ? list.quantity : 0;
        }

        return 0;
      });
    }
    /**
     * Returns list ID.
     *
     * @param {object} options Options object.
     * @param {string} options.endpoints API endpoints.
     * @param {string} options.token User token.
     * @param {string} options.apiLocalePath API locale path.
     * @param {string} options.bagName List name.
     * @returns {Promise<string>} Promise object.
     */

  }, {
    key: "__getListId",
    value: function __getListId(options) {
      return fetch(options.endpoints.ingkaShoppingListService, {
        method: 'POST',
        headers: this.__getHeaders(options),
        body: this.__getListIdBody(options.bagName)
      }).then(this._handleJsonResponse.bind(this)).then(function (response) {
        if (Array.isArray(response.data.lists)) {
          var list = response.data.lists.find(function (list) {
            return list.name === options.bagName;
          });
          return list ? list.listId : null;
        }

        return null;
      });
    }
    /**
     * Creates a list and returns the ID.
     *
     * @param {object} options Options object.
     * @param {string} options.endpoints API endpoints.
     * @param {string} options.token User token.
     * @param {string} options.apiLocalePath API locale path.
     * @param {string} options.bagName List name.
     * @returns {Promise<string>} Promise object.
     */

  }, {
    key: "__createList",
    value: function __createList(options) {
      return fetch(options.endpoints.ingkaShoppingListService, {
        method: 'POST',
        headers: this.__getHeaders(options),
        body: this.__getCreateListBody(options.bagName)
      }).then(this._handleJsonResponse.bind(this)).then(function (response) {
        if (!response.data.createList || !response.data.createList.listId) {
          throw new Error('Failed to create list. Missing "listId" in response.');
        }

        return response.data.createList.listId;
      });
    }
    /**
     * Creates a list and returns the ID.
     *
     * @param {object} options Options object.
     * @param {string} options.endpoints API endpoints.
     * @param {string} options.token User token.
     * @param {string} options.apiLocalePath API locale path.
     * @param {object[]} options.items Items.
     * @param {string} options.listId List ID.
     * @returns {Promise<string>} Promise object.
     */

  }, {
    key: "__addItemsToList",
    value: function __addItemsToList(options) {
      return fetch(options.endpoints.ingkaShoppingListService, {
        method: 'POST',
        headers: this.__getHeaders(options),
        body: this.__getAddItemsBody(options.listId, options.items)
      }).then(this._handleJsonResponse.bind(this)).then(function (response) {
        return {
          CartCount: response.data && response.data.addItems ? response.data.addItems.quantity : null,
          ErrorList: response.errors || []
        };
      });
    }
    /**
     * Sets the shopping list which the latest item was added to as selected.
     *
     * @param {object} options Options Object.
     * @param {string} options.listId ListId.
     * @param {string} options.token User token.
     * @returns {Promise} Object.
     */

  }, {
    key: "__setSelectedList",
    value: function __setSelectedList(options) {
      return fetch(options.endpoints.ingkaShoppingListService, {
        method: 'POST',
        headers: this.__getHeaders(options),
        body: this.__getSelectedListBody(options.listId)
      });
    }
    /**
     * Returns the body.
     *
     * @returns {string} List ID body.
     */

  }, {
    key: "__getListIdBody",
    value: function __getListIdBody() {
      return JSON.stringify({
        operationName: null,
        variables: {},
        query: '{ lists {name, listId} }'
      });
    }
    /**
     * Returns the body.
     *
     * @returns {string} List quantity body.
     */

  }, {
    key: "__getListQuantityBody",
    value: function __getListQuantityBody() {
      return JSON.stringify({
        operationName: null,
        variables: {},
        query: '{ lists {name, quantity} }'
      });
    }
    /**
     * Returns the body.
     *
     * @param {string} listId List ID.
     * @param {object[]} items Items.
     * @returns {string} Mutation body.
     */

  }, {
    key: "__getAddItemsBody",
    value: function __getAddItemsBody(listId, items) {
      var itemsString = "[".concat(items.map(function (item) {
        return "{ itemNo: \"".concat(item.id, "\", quantity: ").concat(item.qty, " }");
      }), "]");
      return JSON.stringify({
        operationName: null,
        variables: {},
        query: "mutation { addItems(items: ".concat(itemsString, ", listId: \"").concat(listId, "\" ) { quantity } }")
      });
    }
    /**
     * Returns the body.
     *
     * @param {string} listId List id.
     * @returns {string} List ID body.
     */

  }, {
    key: "__getSelectedListBody",
    value: function __getSelectedListBody(listId) {
      return JSON.stringify({
        operationName: null,
        variables: {},
        query: "mutation { setSelected(listId: \"".concat(listId, "\" ) { context { userId } } }")
      });
    }
    /**
     * Returns the body.
     *
     * @param {object[]} name Shopping list name.
     * @returns {string} Create list body.
     */

  }, {
    key: "__getCreateListBody",
    value: function __getCreateListBody(name) {
      return JSON.stringify({
        operationName: null,
        variables: {},
        query: "mutation { createList(name: \"".concat(name, "\") { listId } }")
      });
    }
    /**
     * Returns headers.
     *
     * @param {object} options Options object.
     * @param {string} options.token User token.
     * @param {string} options.apiLocalePath API locale path.
     * @param {string} options.clientId Client credential for api.
     * @param {string} options.clientSecret Client credential for api.
     * @returns {object} Headers.
     */

  }, {
    key: "__getHeaders",
    value: function __getHeaders(options) {
      var headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + options.token.value,
        Accept: 'application/json',
        'x-client-id': options.clientId,
        'x-client-secret': options.clientSecret // The below can be used for accessing GraphQL Playground:
        // 'x-user-id': '2008c852-8b33-48f6-b5ef-45add754cdf5',
        // 'x-is-anonymous': true,

      };
      return headers;
    }
    /**
     * Returns the name used by ServiceFactory.
     *
     * @override
     * @returns {string} Factory name.
     */

  }], [{
    key: "factoryName",
    get: function get() {
      return 'onewebshoppinglist';
    }
  }]);

  return OneWebShoppingListService;
}(_AbstractService2.default);

exports.default = OneWebShoppingListService;